<template>
    <div class="payment-method-chart" :class="{ fullscreen: fullScreen }">
        <HalfPieChart :series="getSeries()" :colors="['#cb5d0f', '#4213ce', '#c9d906']" />
        <TableView :cols="getCols()" :rows="getRows()" v-if="tableMode" />
        <div class="stats">
            <StatCard :title="$t('report.total')" :value="stats.TotalSiteCount" unit="site" />
            <StatCard
                :title="paymentMethod.name"
                :value="paymentMethod.value"
                unit="adet"
                :key="index"
                v-for="(paymentMethod, index) in stats.paymentMethods"
            />
        </div>
    </div>
</template>
<script>
import Vue from "vue";
import moment from "moment";
import * as echarts from "echarts/lib/echarts";
import _ from "lodash";
import IconButton from "../../Pages/Settings/components/IconButton.vue";
import HalfPieChart from "../../Pages/Chatbot/pages/reports/charts/HalfPieChart.vue";
import StatCard from "../../Pages/Chatbot/pages/reports/charts/StatCard.vue";
import TableView from "../../Pages/Chatbot/pages/reports/charts/TableView.vue";
import { expertToExcel } from "../../../utils/utils";
import { dateToHourFromSecondsShortFormat } from "../../../utils/filters";
import { ADMIN_REPORT_API, REPORT_API } from "../../../api/statistics";
import log2 from "../../../utils/log2";
import ChartDoddleIcon from "../common/icons/ChartDoddleIcon.vue";
import fscreen from "fscreen";

const log = log2("PaymentMethodChart");
export default Vue.extend({
    name: "PaymentMethodChart",
    components: { ChartDoddleIcon, TableView, IconButton, StatCard, HalfPieChart },
    props: {
        filters: {
            type: Object,
            default: () => ({
                users: [],
                channels: [],
                startDate: moment().startOf("day").toISOString(),
                endDate: moment().endOf("day").toISOString(),
            }),
        },
    },
    data() {
        return {
            colors: ["#FFBF00"],
            stats: {
                TotalSiteCount: 0,
                paymentMethods: [],
            },
            tableMode: false,
            loading: true,
            loadingInstance: null,
            data: [],
            fullScreen: false,
            cancels: [],
        };
    },
    methods: {
        switchToFullScreenMode() {
            if (this.fullScreen) {
                this.closeFullScreenMode();
            } else {
                const elem = document.querySelector(".payment-method-chart");
                fscreen.requestFullscreen(elem);
                this.fullScreen = true;
            }
        },
        closeFullScreenMode() {
            fscreen.exitFullscreen();
        },
        fetch() {
            this.loading = true;
            this.loadingInstance.show();
            ADMIN_REPORT_API.paymentMethodsSites(this.filters)
                .then((res) => {
                    log("paymentMethodsSites data fetched", res);
                    this.data = res;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        getCols() {
            return [
                {
                    key: "paymentMethod",
                    field: "paymentMethod",
                    title: "Ödeme Yöntemi",
                },
                {
                    key: "paymentMethod",
                    field: "siteCount",
                    title: this.$t("report.siteCount"),
                },
            ];
        },
        getRows() {
            const rows = this.data.map((item) => {
                return [item.paymentMethod, item.siteCount];
            });
            return rows;
        },
        getStats() {
            const SiteCounts = this.data.map((x) => x.siteCount);
            const paymentMethods = this.data.map((x) => {
                return {
                    name: x.paymentMethod,
                    value: x.siteCount,
                };
            });
            const isEmpty = SiteCounts.length === 0;
            const TotalSiteCount = isEmpty ? 0 : _.chain(SiteCounts).sum().value();

            return {
                TotalSiteCount,
                paymentMethods,
            };
        },
        getSeries() {
            const data = this.data.map((item) => {
                return { value: item.siteCount, name: item.paymentMethod };
            });
            console.log("data..", data);
            return [
                {
                    name: "Access From",
                    type: "pie",
                    radius: ["40%", "70%"],
                    center: ["50%", "70%"],
                    startAngle: 180,
                    endAngle: 360,
                    data,
                },
            ];
        },
        exportToExcel() {
            const data = this.data.map((item) => {
                return [item.siteCount, item.paymentMethod];
            });
            const stats = this.getStats();
            const excelData = [
                ...data,
                {
                    date: "Toplam site",
                    siteCount: stats.TotalSiteCount,
                },
                {
                    date: "Ödeme Yöntemi",
                    siteCount: stats.paymentMethods,
                },
            ];
            expertToExcel(excelData, `site_payment-methods_.xlsx`, "Sheet 1");
        },
    },
    created() {
        const fullscreenCallback = () => {
            console.log("fullscreenCallback", fscreen.fullscreenElement);
            this.fullScreen = fscreen.fullscreenElement !== null;
            this.$forceUpdate();
        };
        fscreen.addEventListener("fullscreenchange", fullscreenCallback);
        this.cancels.push(() => {
            fscreen.removeEventListener("fullscreenchange", fullscreenCallback);
        });
    },
    beforeDestroy() {
        this.cancels.forEach((cancel) => cancel());
    },
    mounted() {
        this.loadingInstance = this.$veLoading({
            target: document.querySelector(".payment-method-chart"),
            name: "wave",
        });
        this.stats = this.getStats();
        this.fetch();
    },
    watch: {
        filters: {
            handler: function (val, oldVal) {
                this.fetch();
            },
            deep: true,
        },
        data: {
            handler: function (val, oldVal) {
                this.stats = this.getStats();
            },
            deep: true,
        },
        loading(val) {
            if (val) {
                this.loadingInstance.show();
            } else {
                this.loadingInstance.close();
            }
        },
    },
});
</script>
<style lang="scss">
.payment-method-chart {
    .title {
        display: flex;
        gap: 4px;
        align-items: center;
        justify-content: center;
        margin: 0;

        h2 {
            text-align: center;
            font-weight: 700;
            font-size: 40px;
            margin: 0 !important;
        }
    }

    &.fullscreen {
        background-color: #fff;
        padding: 20px;
        overflow-y: scroll;

        .stacked-area-chart {
            height: calc(100vh - 200px);
        }
    }
}
</style>
<style scoped lang="scss">
.payment-method-chart {
    display: flex;
    flex-direction: column;
    gap: 10px;

    .toolbar {
        display: flex;
        justify-content: space-between;

        .left {
            display: flex;

            .buttons {
                display: flex;
                border: 1px solid var(--color-border-default);

                .icon-button {
                    padding: 5px;
                    width: 40px;
                    height: 34px;
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    border-right: 1px solid var(--color-border-default);
                    border-radius: unset !important;

                    &.selected {
                        background-color: var(--color-bg-info-low-hover);

                        i {
                            color: rgb(55, 162, 255);
                        }
                    }

                    &:hover {
                        background-color: var(--color-bg-neutral-pressed);
                    }
                }

                .icon-button:last-child {
                    border-right: none;
                }
            }
        }

        .right {
            display: flex;
            justify-content: flex-end;
        }
    }

    .stats {
        display: flex;
        flex-direction: row;
        gap: 10px;
        flex-wrap: wrap;
    }
}
</style>
